module.exports = "/packs/images/svg/facilities/physio_clinic_old~6fc5088f8b111f982c59593337dc37a0.svg";